import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { adminApi, errMsg } from "@/lib/api";
import { toast } from "sonner";

const MODOS = [["padrao", "Regra geral"], ["liberado", "Liberar (piloto)"], ["bloqueado", "Bloquear"]];

// Regra própria da loja para cada nota fiscal. "Regra geral" segue o que está em Admin Master → Fiscal → Documentos.
export function FiscalDocumentosLojaBox({ tenantId, documentos = {}, onChanged }) {
  const [motivo, setMotivo] = useState("");
  const [busy, setBusy] = useState(false);
  const alterar = async (tipo, modo) => {
    if (motivo.trim().length < 5) { toast.error("Escreva o motivo (mínimo 5 caracteres)"); return; }
    setBusy(true);
    try {
      await adminApi.put(`/tenants/${tenantId}/fiscal-documentos`, { tipo, modo, motivo: motivo.trim() });
      toast.success("Regra da loja salva");
      setMotivo(""); onChanged();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="space-y-2 border-t pt-4" data-testid="fiscal-documentos-loja">
      <p className="font-semibold">Notas fiscais desta loja</p>
      {Object.entries(documentos).map(([k, x]) => (
        <div key={k} className="flex flex-wrap items-center justify-between gap-2 rounded-lg border px-3 py-2">
          <span>{x.nome}: <b className={x.liberado ? "text-emerald-600" : "text-red-600"}>{x.liberado ? "pode emitir" : "não pode emitir"}</b>
            <span className="ml-1 text-xs text-muted-foreground">(regra geral: {x.geral ? "ligada" : "desligada"})</span></span>
          <div className="flex gap-1">
            {MODOS.map(([m, l]) => (
              <Button key={m} size="sm" variant={x.modo_loja === m ? "default" : "outline"} disabled={busy || x.modo_loja === m}
                onClick={() => alterar(k, m)} data-testid={`fiscal-doc-loja-${k}-${m}`}>{l}</Button>
            ))}
          </div>
        </div>
      ))}
      <Input placeholder="Motivo (obrigatório): ex. loja piloto para testar NFC-e" value={motivo} onChange={(e) => setMotivo(e.target.value)} maxLength={300} data-testid="fiscal-doc-loja-motivo" />
    </div>
  );
}
